import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=2da12729&scoped=true"
import script from "./Wizard.vue?vue&type=script&lang=ts"
export * from "./Wizard.vue?vue&type=script&lang=ts"
import style0 from "./Wizard.vue?vue&type=style&index=0&id=2da12729&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da12729",
  null
  
)

export default component.exports